import { useState, useEffect } from 'react';

const useBeforeFirstRender = fn => {
  const [hasRendered, setHasRendered] = useState(false);
  useEffect(() => setHasRendered(true), [hasRendered]);
  if (!hasRendered) fn();
};

export default useBeforeFirstRender;
